<template>
  <div class="reports-dashboard">
    <div class="container mt-5 mb-5">
      <h4 class="text-center">Devoluciones a proveedor</h4>
      <div class="row">
        <div class="col-md-4 mt-4 mb-4" v-for="report in reports" :key="report.id">
          <router-link
            :to="{ name: report.router_link, params: { provider_id: report.provider } } "
            class="card-adela-anchor"
            >
            <!-- v-if="$can('read', report.subject)" -->
            <div class="card-adela-item card-adela-diseno">
              <div class="card-adela-badge" style="background-color:#513692">
                <font-awesome-icon :icon="['fa', report.icon]" />
              </div>
              <div class="card-adela-category">
                <h2>{{ report.title }}</h2>
                <span>{{ report.description }}</span>
              </div>
            </div>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>
<script type="text/javascript">
import axiosAdelaService from '@/axios/axiosAdelaService'
import { mapGetters } from 'vuex'

export default {
  data () {
    return {
      reports: [
        {
          id: 1,
          icon: 'plus',
          title: 'Nueva Devolución',
          description: 'Crear Devolucion genreal',
          router_link: 'genrealDevolutionsProvider',
          subject: 'GeneralReport'
        },
        {
          id: 2,
          icon: 'calendar',
          title: 'Reporte por de fecha',
          description: 'Crear Devolucion genreal',
          router_link: 'genrealDevolutionsListDates',
          subject: 'GeneralReport'
        },
        {
          id: 3,
          icon: 'tshirt',
          title: 'Reporte por proveedor',
          description: 'Crear Devolucion genreal',
          router_link: 'genrealDevolutionsProvider',
          subject: 'GeneralReport'
        }
      ]
    }
  },
  computed: {
    ...mapGetters({
      user: 'getUser'
    })
  },
  methods: {
    async getDevolutions () {
      try {
        this.disabled = true
        const request = {
          enterprise_id: this.user.enterprise_id
        }
        console.log('request', request)
        const response = await axiosAdelaService.post('/dashProviderDevolutions', request)
        console.log('dashProviderDevolutions', response)
        if (response.status === 200) {
          const data = response.data.rows
          console.log(data)
          for (const key in data) {
            console.log('data', parseInt(key) + 2)
            this.reports.push({
              id: parseInt(key) + 2,
              icon: 'puzzle-piece',
              title: data[key].name,
              description: 'Devolucion a proveedor',
              router_link: 'genrealDevolutionsList',
              subject: 'GeneralReport',
              provider: data[key].provider_id
            })
          }
        }
      } catch (error) {
        console.log('error', error)
      }
    }
  },
  async mounted () {
    await this.getDevolutions()
  }
}
</script>
